// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2iHLu","range":"MonthRangeSwitch_range__tyeFe","disabled":"MonthRangeSwitch_disabled__6_MGy"};